<template>
  <div>
    <label class="block text-sm font-bold text-gray-600">{{ label }}</label>
    <input
      :disabled="disabled"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      type="text"
      :placeholder="placeholder"
      class="mt-1 py-2 px-3 block w-full border border-gray-300 text-sm rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 disabled:opacity-50"
    />
  </div>
</template>

<script>
export default {
  name: "TextField",
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    modelValue: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean
    }
  }
};
</script>
